// extracted by mini-css-extract-plugin
module.exports = {"TitleCard":"styles_TitleCard__1L47Q","primaryTitle":"styles_primaryTitle__2Dqwc","onSurfaceTitle":"styles_onSurfaceTitle__24fzN"};